"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var LineThicknessRegular = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_LineThicknessRegular_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 1,
    width: 6,
    height: 14
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.553 1.606a1 1 0 0 1 .9 1.785l-.104.056a7.816 7.816 0 0 0-1.209.821C7.422 4.866 7 5.481 7 6c0 .09.009.144.016.173a1.2 1.2 0 0 0 .331.06c.173.015.384.017.653.017h.089c.437 0 1.108-.001 1.67.233.34.142.678.38.918.766.234.376.323.808.323 1.251 0 .8-.385 1.567-.793 2.18-.426.639-.976 1.254-1.5 1.777a21.907 21.907 0 0 1-1.917 1.696l-.003.003-.187.144a1 1 0 0 1-1.203-1.597l.159-.123a19.932 19.932 0 0 0 1.737-1.537c.476-.477.926-.987 1.25-1.473C8.885 9.057 9 8.7 9 8.5a.754.754 0 0 0-.016-.173 1.2 1.2 0 0 0-.331-.06A8.623 8.623 0 0 0 8 8.25h-.088c-.438 0-1.109.001-1.672-.233a1.936 1.936 0 0 1-.917-.766C5.089 6.875 5 6.443 5 6c0-1.482 1.078-2.617 1.86-3.268a9.812 9.812 0 0 1 1.53-1.04l.007-.004.154-.081.002-.001Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_LineThicknessRegular_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = LineThicknessRegular;
exports["default"] = _default;